import React, { useEffect, useState } from 'react'

export default function InputHandler({ form_data, setFormData, Name = "input", Type = "text", Label = "", is_disabled = false }) {
  return (
    <div className='form-group'>
      <label className="form-label">{Label}</label>

      {is_disabled ?
        <input
          type={Type}
          placeholder={`Enter ${Label}`}
          className="form-control mb-1"
          value={form_data[Name]}
          disabled={true}
        />
        :
        <input
          type={Type}
          placeholder={`Enter ${Label}`}
          className="form-control mb-1"
          value={form_data[Name]}
          onChange={(e) => setFormData({ ...form_data, [Name]: e.target.value })}
        />
      }
    </div>
  )
}
